export const defaultProjectScreenshots = {
  parcels_uploadcare: null,
  satellite_uploadcare: null,
  situation_uploadcare: null,
};
